// src/utils/version.ts
// Version policy:
// - beta.N: staging builds while planned feature work is still landing.
// - rc.N: release-candidate builds after feature freeze, for bug fixes only.
// - final: client release after testing signoff, without the beta/rc suffix.
export const appVersion: string = "2.8.0-beta.2";
